import React, { memo, useMemo } from "react";
import SurveyPreview from "./SurveyPreview";
import CustomPostPreview from "./CustomPostPreview";
import {
	CURR_PREVIEW_TYPE,
	PREVIEW_TYPE_CONFIG,
	PREVIEW_TYPE,
} from "../../conf";
import inPreview from "../../utils/inPreview";

const SurfacesPreview = memo(() => {
	const previewIdx = useMemo(() => {
		if (!(CURR_PREVIEW_TYPE in PREVIEW_TYPE_CONFIG)) {
			return false;
		}
		return CURR_PREVIEW_TYPE;
	}, []);

	if (!inPreview || !previewIdx) {
		return null;
	}

	return (
		<>
			{previewIdx === PREVIEW_TYPE.SURVEY && <SurveyPreview />}
			{previewIdx === PREVIEW_TYPE.CUSTOM_POST && <CustomPostPreview />}
		</>
	);
});

export default SurfacesPreview;
